import Vue from 'vue'
import VueRouter from 'vue-router'
import navConfig from './conf/nav'
Vue.use(VueRouter)

let routes = [] // 路由配置表

function handleRouterConfig (conf) {
  // 确保 path 和 name 是字符串
  let path = '/' + String(conf.path || '');
  let name = String(conf.path || '').replace(new RegExp('\\/', 'g'), '_');

  // 使用 import() 动态加载组件
  let component = () => import('./view/' + conf.component);

  let redirect = conf.redirect;
  let route = { path, name, component, redirect };

  // 处理子路由
  if (Array.isArray(conf.children))
  {
    route.children = [];
    for (let child of conf.children)
    {
      if (child && typeof child === 'object')
      {
        let childRoute = handleRouterConfig(child);
        if (childRoute)
        {
          route.children.push(childRoute);
        }
      }
    }
  }

  return route;
}

navConfig.map(nav => {
  let route = handleRouterConfig(nav)
  routes.push(route)
})

const router = new VueRouter({
  mode: 'history',
  routes
})

/**
 * 路由跳转之前的钩子
 */
router.beforeEach((to, from, next) => {
  console.log(to.path, 'to.path ')
  let token = localStorage.getItem('tokenCompany')
  let certificationStatus = localStorage.getItem('certificationStatus')
  let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : ''
  // localStorage.setItem("userInfo", JSON.stringify(res.data));
  if (token && certificationStatus == 3 && userInfo.realnameStatus == 3)
  {
    // if (to.path === '/login') {

    // } else {

    // }
    next()
  } else
  {
    if (to.path === '/login' || to.path === '/signup' || to.path === '/revisePass' || to.path === '/privacy' || to.path === '/privacyferter')
    {
      next()
    } else
    {
      if (token && (to.path === '/wanshan' || to.path === '/enterprisecertification'))
      {
        next()
      } else
      {
        if (token && userInfo.businessId)
        {
          if (certificationStatus != 3 || userInfo.realnameStatus != 3)
          {
            next('/enterprisecertification')
          } else
          {
            next('/login')
          }
        } else if (token && !userInfo.businessId)
        {
          next('/wanshan')
        } else
        {
          next('/login')
        }
      }
      // Vue.prototype.$message.warning('登录失效！')

    }
  }
})


export default router



// WEBPACK FOOTER //
// ./src/router.js